import * as api from 'api/external-api';

export const fetchEAUsers = params => ({
  type: 'FETCH_EA_USERS',
  payload: api.fetchEAUsers(params),
});
